import script from "./StatusMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusMapping.vue?vue&type=script&setup=true&lang=js"

import "./StatusMapping.vue?vue&type=style&index=0&id=3c42c3bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c42c3bc"]])

export default __exports__